import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import DatePicker from 'components/core/DatePicker';
// Custom
import { dateFormatter } from 'utils/DateUtils';
import { DisabledContext } from 'components/misc/Contexts';

const DateFilter = ({
  labelId, timezone, type, value, onChange,
}) => {
  const handleDateChange = (date) => {
    const formattedDate = date && type === 'begin'
      ? dateFormatter.toServerFormat(date, timezone, { hour: 0, minute: 0, second: 0 })
      : dateFormatter.toServerFormat(date, timezone, { hour: 23, minute: 59, second: 59 });
    onChange(formattedDate);
  };

  return (
    <DisabledContext.Consumer>
      {(disabled) => (
        <DatePicker
          disabled={disabled}
          label={<LocalizedMessage id={labelId} />}
          value={value}
          clearable
          onChange={handleDateChange}
        />
      )}
    </DisabledContext.Consumer>
  );
};

DateFilter.propTypes = {
  labelId: PropTypes.string.isRequired,
  timezone: PropTypes.string,
  type: PropTypes.oneOf(['begin', 'end']),
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
};

DateFilter.defaultProps = {
  timezone: null,
  value: null,
  type: 'begin',
};

module.exports = DateFilter;



// WEBPACK FOOTER //
// ./components/filters/DateFilter.js